import { Navigate, RouteObject } from 'react-router-dom';

import {
  ADMIN,
  ADMIN_PAGE_NOT_FOUND,
  AUTH,
  DASHBOARD,
  HOME,
  PAGE_NOT_FOUND
} from '@constants/routes';
import AdminRoutes from '@features/admin/routes';
import AuthRoutes from '@features/authentication/routes';
import BranchRoutes from '@features/branch-management/routes';
import DashboardRoutes from '@features/dashboard/pages/routes';
import DocsRoutes from '@features/docs/routes';
import EventRoutes from '@features/event-registration/routes';
import ExpenseTrackerRoutes from '@features/expense-tracker/routes';
import GroupRoutes from '@features/group-management/routes';
import HelpRoutes from '@features/help/routes';
import MemberRoutes from '@features/member-management/routes';
import PageNotFoundRoutes, {
  AdminPageNotFoundRoutes
} from '@features/page-not-found/routes';
import QuickCollectRoutes from '@features/quick-collect/routes';
import ReportsRoutes from '@features/reports/routes';
import OrgRoutes from '@features/settings/routes';
import SubscriptionPlanRoutes from '@features/subscription/routes';
import TeamManagementRoutes from '@features/team-management/routes';
import TransactionsRoutes from '@features/transactions/routes';
import AdminLayout from '@layouts/admin-layout/AdminLayout';
import MainLayout from '@layouts/main-layout/MainLayout';
import { getLocalStorageItem } from '@utils/storage';

export const mainRoutes: RouteObject[] = [
  AuthRoutes,
  {
    path: HOME,
    element: (
      <Navigate to={getLocalStorageItem('token') ? DASHBOARD : AUTH.LOGIN} />
    )
  },
  {
    element: <MainLayout />, // Outlet in MainLayout will be replaced by matching element from below
    children: [
      ...GroupRoutes,
      ...BranchRoutes,
      ...DocsRoutes,
      ...TeamManagementRoutes,
      ...PageNotFoundRoutes,
      ...HelpRoutes,
      DashboardRoutes,
      ...TransactionsRoutes,
      ...SubscriptionPlanRoutes,
      ReportsRoutes,
      ...QuickCollectRoutes,
      ...OrgRoutes,
      ...MemberRoutes,
      ...EventRoutes,
      ...ExpenseTrackerRoutes
    ]
  },
  {
    path: '*',
    element: <Navigate to={PAGE_NOT_FOUND} />
  }
];

export const adminRoutes: RouteObject[] = [
  AuthRoutes,
  {
    path: HOME,
    element: (
      <Navigate
        to={getLocalStorageItem('token') ? ADMIN.KYC_DOCUMENTS : AUTH.LOGIN}
      />
    )
  },
  {
    element: <AdminLayout />,
    // Outlet in AdminLayout will be replaced by matching element from below
    children: [...AdminRoutes, ...AdminPageNotFoundRoutes]
  },
  {
    path: '*',
    element: <Navigate to={ADMIN_PAGE_NOT_FOUND} />
  }
];
